<script setup>
import { useRoute } from 'vue-router'

const route = useRoute()
</script>

<template>
  <main class="succes container" aria-labelledby="titre-rechargement-succes">
    <h1 id="titre-rechargement-succes">Rechargement terminé</h1>
    <p class="text-center my-3 fs-5" role="status">
      Merci d'avoir rechargé votre abonnement
    </p>
    <p class="text-center">
      Votre commande numéro
      <strong>{{ route.query.numeroCommande }}</strong>
      a été enregistrée.
    </p>
    <p class="text-center">
      Un email vient de vous être envoyé confirmant votre renouvellement d'abonnement.
    </p>
  </main>
</template>

<style scoped lang="scss">
@import "@/assets/main";

h1 {
  color: $firstcolor;
  text-align: center;
}
</style>
